import { useMemo } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";

import { resolveSubscriptionPlansFromData } from "./memberPlansData";
import { MemberProduct, PayChannel } from "../features/api/memberApi";

export const useMemberPlansHandle = ({
  data,
  billingCycle,
}: {
  data: MemberProduct[];
  billingCycle: string;
}) => {
  const isApp = deviceDetector.isApp();
  const payChannel = deviceDetector.isIOSApp()
    ? PayChannel.APPLE_IAP
    : PayChannel.GOOGLE_IAP;

  const subscriptionPlans = useMemo(
    () =>
      resolveSubscriptionPlansFromData(data, billingCycle, {
        isApp,
        payChannel,
      }),
    [billingCycle, data, isApp, payChannel],
  );

  // TODO: 后续需要根据接口返回数据判断是否有活动正在进行中，目前没有相关配置和字段
  const hasActiveDiscount = false;

  return {
    subscriptionPlans,
    hasActiveDiscount,
  };
};
